import { z } from 'zod'

export const previewSandboxAccountsSchema = z.object({
  token: z.string().min(10).max(200),
})
export type PreviewSandboxAccountsDto = z.infer<typeof previewSandboxAccountsSchema>

export const sandboxAccountPreviewSchema = z.object({
  tbankAccountId: z.string(),
  name: z.string(),
  totalRub: z.string(), // Decimal string
  alreadyBound: z.boolean(),
})
export const sandboxAccountsPreviewResponseSchema = z.array(sandboxAccountPreviewSchema)
export type SandboxAccountPreviewDto = z.infer<typeof sandboxAccountPreviewSchema>
